import _ from "lodash";
import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import LoadingOverlay from "react-loading-overlay";
import { Col, Row } from "react-bootstrap";
import BasicLayout from "../../../layouts/basiclayout";
import { confirmAlert } from "react-confirm-alert";
import AppModal from "../../../widgets/modal";
import { ScaleLoader } from "react-spinners";
import QalboxTable from "../../../widgets/qalbox-table";
import { PanelistModal } from "./panelistModal";
import { getPanelistDisplayData } from "./helpers/panelistDataTransform";
import { getPanelistColumns } from "./helpers/panelistColumns";
import { useFetchPanelist } from "./hooks/useFetchPanelist";
import { useDeletePanelist } from "./hooks/useDeletePanelist";
import { getDeletablePanelist } from "./helpers/deletablePanelist";

const QalboxPanelist = () => {
  const [refresh, setRefresh] = useState(false);
  const [ShowPanelistModal, setShowPanelistModal] = useState(false);
  const [panelistRow, setPanelistRow] = useState(null);
  const [panelistResponse, isLoadingPanelist, errorFetching] = useFetchPanelist(refresh);
  const [deletePanelist, isDeleting] = useDeletePanelist();

  const onDeleteSelected = (selectedFlatRows, resetSelectedRows) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <AppModal
            show={true}
            showBody={true}
            headingText={`Are you sure want to delete the following ${_.size(
              selectedFlatRows
            )} panelist items ?`}
            modalBody={getDeletablePanelist(selectedFlatRows)}
            modalBodyClassName={"precalcs-diff-merge-view"}
            closeButtonText={"No"}
            okButtonText={"Yes, Delete"}
            handleClose={onClose}
            handleOk={() => {
              onClose();
              const uuidListToDelete = _.map(selectedFlatRows, "values.id.props.text");
              _.forEach(uuidListToDelete, id => {
                deletePanelist(id, handleRefresh);
              });

              alert('Successfully Deleted !!!');
              resetSelectedRows();
            }}
          />
        );
      },
    });
  };

  const onEditClicked = (selectedFlatRows, resetSelectedRows) => {
    const id = _.get(selectedFlatRows, '[0].values.id.props.text', null);
    const shortMediaItem = panelistResponse.find(item => item.id === id);
    setPanelistRow(shortMediaItem);
    setShowPanelistModal(true);
    resetSelectedRows();
  };

  const handleRefresh = () => {
    setRefresh(prevRefresh => !prevRefresh);
  };

  const onUpdate = (response) => {
    setShowPanelistModal(false);
    handleRefresh();
  };

  const handleCreate = () => {
    setPanelistRow(null);
    setShowPanelistModal(true);
  };

  return (
    <LoadingOverlay
      active={isLoadingPanelist || isDeleting}
      spinner={<ScaleLoader />}
      text={isDeleting ? "Deleting the selected organization items." : "Loading Organization..."}
    >
      <BasicLayout pagePermission="moderate_precalc">
        <ToastContainer autoClose={2000} />
        <Row>
          <Col md={9}>
            <h3 className="content_editor_title">{"Panelist"}</h3>
          </Col>
          <Col md={3} style={{ paddingTop: "20px" }}>
            <button
              style={{
                display: "inline-block",
                padding: "10px 20px",
                backgroundColor: "green",
                color: "white",
                textDecoration: "none",
                borderRadius: "4px",
              }}
              onClick={handleCreate}
            >
              Create
            </button>
          </Col>
        </Row>
        <QalboxTable
          table={{
            data: getPanelistDisplayData(panelistResponse),
            columns: getPanelistColumns(),
            handleDelete: onDeleteSelected,
            handleEdit: onEditClicked,
            isLoading: isLoadingPanelist,
            tableError: errorFetching,
          }}
        />
      </BasicLayout>
      <AppModal
        show={ShowPanelistModal}
        showBody={true}
        headingText={`Create Panelist`}
        modalBody={
          <PanelistModal
            data={panelistRow}
            handleUpdates={onUpdate}
          />
        }
        modalBodyClassName={""}
        closeButtonText={""}
        okButtonText={""}
        handleClose={() => {setShowPanelistModal(false); setPanelistRow(null)}}
      />
    </LoadingOverlay>
  );
};

export default QalboxPanelist;
